import React from "react";
import Hero from "../components/Hero";
import AreasOfFocus from "../components/AreasOfFocus";
import AboutSection from "../components/AboutSection";
import CampaignCards from "../components/CampaignCards";

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <AreasOfFocus />
      <AboutSection />
      <CampaignCards />

      {/* Call to action section */}
      <section className="py-16 bg-gradient-to-r from-primary to-secondary text-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              The Way You Help Us!
            </h2>
            <p className="text-lg mb-8">
              By donating to Lifeline Foundation NGO, you support vital programs
              that empower women, educate communities, enhance rural health, and
              promote sustainable development. Every donation helps us continue
              our mission to create a lasting impact in the lives of those in
              need. Join us in making a difference.
            </p>
            <a
              href="/donate"
              className="inline-block bg-white text-primary font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors"
            >
              Donate Now
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
